export default __webpack_public_path__ + "static/1-c9af87a3eeb68bd37a70c8beaeeb26c5.jpeg";